import { DatePipe, DecimalPipe, TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxsModule } from '@ngxs/store';
import {
  AuditCommonService,
  AuditConfigState,
  AuditDashboardDataService,
  AuditDataCountState,
  AuditDataService,
  AuditDataTableService,
  AuditDimensionDataState,
  AuditExportCsvService,
  AuditFindAndCompareService,
  AuditServiceDetailService,
  AuditStateService,
  AuditSummaryDataService,
  AuditSummaryState,
  BrrProfilesService,
  CrossfilterState,
  DataFilterState,
  DataSourcesState,
  DateDurationPickerState,
  FindAndCompareGridService,
  SavedFilterState,
  ServiceFilterState,
  ServiceVisibilityConfigState,
  SitesDataService,
} from '@app-new-gen/audit/common';
import { CasbCommonModule } from '@casb/navigation';
import { TranslateModuleHelper } from '@casb/i18n';
import { SpanvaDataService } from '@casb/spanva';
import {
  APIDataService,
  AzMetadataService,
  MetadataService,
  NewServiceRecommendAdditionService,
  ServiceBrrState,
  TagsDataService,
  TagsState,
} from '@app-new-gen/shared/ui-common';
import { DateTranslationService } from '@casb/date-util';
import { BytesPipe, DurationPipe, PipesModule, SizePipe } from '@casb/pipes';
import { CasbRbacModule } from '@casb/rbac';
import { CasbSvgIconModule } from '@casb/svg-icon';
import { ButtonModule } from '@sym-ui/toolkit';
import { AuditSharedModule } from './components/audit-shared/audit-shared.module';
import { DateDurationPickerService } from './services/date-duration-picker/date-duration-picker.service';
import { ServiceCommentService } from './services/service-comment/service-comment.service';
@NgModule({
  imports: [
    CasbCommonModule,
    RouterModule.forChild([
      {
        path: 'compareservices',
        loadChildren: () =>
          import('./components/audit-compare-services/audit-compare-services.module').then(
            (m) => m.AuditCompareServicesModule,
          ),
      },
      {
        path: 'requestedservices',
        loadChildren: () =>
          import('./components/review-services/review-services-lazy.module').then(
            (m) => m.ReviewServicesLazyModule,
          ),
      },
      {
        path: 'preferences',
        loadChildren: () =>
          import('./components/preferences/audit-preferences.module').then(
            (m) => m.AuditPreferencesModule,
          ),
      },
      {
        path: 'infographic',
        loadChildren: () => import('./components/report/report.module').then((m) => m.ReportModule),
      },
      {
        path: 'firewall',
        loadChildren: () =>
          import('./components/device-logs/device-logs.module').then((m) => m.DeviceLogsModule),
      },
      {
        path: '',
        loadChildren: () =>
          import('./components/audit-dashboard/audit-dashboard.module').then(
            (m) => m.AuditDashboardModule,
          ),
      },
      { path: '**', redirectTo: '' },
    ]),
    TranslateModule.forChild(TranslateModuleHelper.getConfig(['appAudit'])),
    NgxsModule.forFeature([
      DataSourcesState,
      ServiceVisibilityConfigState,
      CrossfilterState,
      AuditSummaryState,
      AuditConfigState,
      ServiceFilterState,
      ServiceBrrState,
      SavedFilterState,
      TagsState,
      AuditDataCountState,
      AuditDimensionDataState,
      DataFilterState,
      DateDurationPickerState,
    ]),
    CasbSvgIconModule,
    AuditSharedModule,
    CasbRbacModule,
    PipesModule,
  ],
  exports: [ButtonModule],
  providers: [
    BytesPipe,
    SizePipe,
    DurationPipe,
    DecimalPipe,
    DatePipe,
    TitleCasePipe,
    DateTranslationService,
    MetadataService,
    APIDataService,
    AuditCommonService,
    AuditDataService,
    AuditSummaryDataService,
    AuditDataTableService,
    SpanvaDataService,
    AzMetadataService,
    TagsDataService,
    AuditDashboardDataService,
    AuditStateService,
    DateDurationPickerService,
    ServiceCommentService,
    AuditServiceDetailService,
    AuditExportCsvService,
    BrrProfilesService,
    AuditFindAndCompareService,
    FindAndCompareGridService,
    NewServiceRecommendAdditionService,
    SitesDataService,
  ],
})
export class AuditFeatureModule {}
